import { apiCall } from "../../services/api-service.js";

export const getQuotationListApi = async (params) => {
    try {
        const response = await apiCall("get", "purchase_quotation", null, {
            params,
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};